import { render, staticRenderFns } from "./DepositScenarioSimulator.vue?vue&type=template&id=27f19c10"
import script from "./DepositScenarioSimulator.vue?vue&type=script&lang=js"
export * from "./DepositScenarioSimulator.vue?vue&type=script&lang=js"
import style0 from "./DepositScenarioSimulator.vue?vue&type=style&index=0&id=27f19c10&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f19c10')) {
      api.createRecord('27f19c10', component.options)
    } else {
      api.reload('27f19c10', component.options)
    }
    module.hot.accept("./DepositScenarioSimulator.vue?vue&type=template&id=27f19c10", function () {
      api.rerender('27f19c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Resources/DepositScenarioSimulator.vue"
export default component.exports